import { render, staticRenderFns } from "./PageModeler.vue?vue&type=template&id=fc49831e&"
import script from "./PageModeler.vue?vue&type=script&lang=ts&"
export * from "./PageModeler.vue?vue&type=script&lang=ts&"
import style0 from "./PageModeler.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports